/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// FIXME: VTL CLEANSE WHERE APPLICABLE - SOME FUNCTIONS HERE MAY REFER TO DEPRECATED PAGES/LAYOUTS

(function($) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Halt = {
		// All pages
		common: {
			init: function() {
				// Announcement Reveal/Hide
				$('#announcementReveal').on('click', function() {
					$('body').addClass('announcement--visible');
				});
				$('#announcementHide').on('click', function() {
					$('body').removeClass('announcement--visible');
				});

				// Side Nav Logic
				$('.side-nav .nav__item--parent > a').on('click', function(e) {
					e.preventDefault();
					$(this)
						.siblings('.nav__sub-menu')
						.slideToggle();
					$(this).toggleClass('sub-nav--open');
				});

				$('#sideNavOpen').on('click', function() {
					$('body').addClass('side-nav--open');
				});
				$('#sideNavClose').on('click', function() {
					$('body').removeClass('side-nav--open');
				});

				// Testimony Drawer Slider Init
				$('.testimonies').slick({
					dots: true,
					arrows: false,
					autoplay: true,
					autoplaySpeed: 30000
				});

				// Hero Area Slider Init
				$('.hero-slides').slick({
					arrows: false,
					dots: true,
					autoplay: true,
					autoplaySpeed: 60000
				});

				//Slick
				$('.slick').slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [
						{
						  breakpoint: 600,
						  settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						  }
						},
						{
						  breakpoint: 480,
						  settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						  }
						}
					  ]
				  });
				var clock;
				if($('.clock').length && !$(document.body).hasClass('wp-admin')){
					var t1 = $('.clock').data('start') == 'now' ? new Date() :$('.clock').data('start');
					var t2 = new Date($('.clock').data('stop'));
					var dif = t2.getTime() - t1.getTime();
					if(dif > 0){
						var seconds_dif = dif/1000;
						var clockface = $('.clock').data('clockface');
						var message = $('.clock').data('message');
						var countdown = $('.clock').data('countdown');
						clock = $('.clock').FlipClock(seconds_dif,{
							clockFace: clockface,
							autoStart: true,
							countdown: countdown,
							callbacks: {
								stop: function() {
									$('.message').html(message);
								}
							}
						});
					}else{
						if($('.clock').parents('.wysiwyg_columns').length){
							$('.clock').closest('.core').remove();
						}else{
							console.log('else');
							//$('.clock-label').remove();
							//$('.clock').remove();
						}
					}
				}

				//Function to display social share in centered pop-up
				function windowPopup(url, width, height) {
					// Calculate the position of the popup so
					// it’s centered on the screen.
					var left = screen.width / 2 - width / 2,
						top = screen.height / 2 - height / 2;

					window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
				}
				$('.social-share__link').on('click', function(e) {
					e.preventDefault();
					windowPopup($(this).attr('href'), 500, 375);
				});

				// Posts sort section swapping
				$('.blog-view-list__item').on('click', function(el) {
					$this = $(this);
					$section = $this.data('section');
					$this
						.addClass('current')
						.siblings()
						.removeClass('current');
					$('.sort-section').hide();
					$('#' + $section).show();
				});

				$('#blog-categories').on('click', function() {
					$('#blog-categories-list').toggle();
				});
				//customer portal auto-submit
				$('#gform_1 #input_1_1').change(function() {
					$form = this.closest('form');
					$form.submit();
			   });
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				$('.equal-height').matchHeight();
				var hash = window.location.hash;
				if(hash){
					$('html, body').animate({
						scrollTop: $(hash).offset().top -300
					}, 2000);
				}
			}
		},
		single: {
			init: function() {
				$('.blog-post img')
					.not('.blog-post a > img, .post-image-container img, .avatar')
					.on('click', function() {
						lity($(this).attr('src'));
					});
			},
			finalize: function() {}
		},
		post_type_archive_product: {
			init: function() {
				$('.clear-control .clear').on('click', function() {
					Marketplace.clearFacet($(this).data('clear'));
				});

				$(document).on('facetwp-refresh', function() {
					$('.clear-control').removeClass('show');
				});

				$(document).on('facetwp-loaded', function() {
					$.each(FWP.facets, function(facet) {
						if (FWP.facets[facet].length > 0) {
							$('[data-clear="' + facet + '"]')
								.parent()
								.addClass('show');
						} else {
							$('[data-clear="' + facet + '"]')
								.parent()
								.removeClass('show');
						}
					});
				});
			}
		},
		single_product: {
			init: function() {
				Marketplace.productSliderInit();

				$('#more-info-modal-open').on('click', function() {
					$('#more-info-modal, #modal-blocker').fadeIn(200);
				});

				$('#more-info-modal-close').on('click', function() {
					$('#more-info-modal, #modal-blocker').fadeOut(200);
				});

				$('#product-video-play').on('click', function() {
					Wistia.api().play();
				});

				new LuminousGallery(document.querySelectorAll('.lightbox-item'));
			}
		},
		single_vendors: {
			init: function() {
				$('#vendor-products-list').slick({
					slidesToShow: 4,
					infinite: false,
					prevArrow: '.vendor-products__prev',
					nextArrow: '.vendor-products__next'
				});
			}
		},
		page_id_5310: {
			init: function() {
				if(!$(document.body).hasClass('travelclick')){
					var callouts = $('.m-full-callout');
					var button = $(callouts[1]).find('.btn.btn--standard');
					button.on('click', function(e) {
						e.preventDefault();
						$('.m-form-drawer').css({
							'max-height':'900px',
							'padding':'2rem 0'
						});
					});
				}
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Halt;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
